/**
 * 标记为重做 - 确认弹窗
 */
import React from 'react';
import { Modal } from 'antd';

export default function ConfirmRedoModal({ visible, onCancel, onConfirm, content }) {
    const handleCancel = () => {
        onCancel?.();
    };

    const handleOk = () => {
        onConfirm?.();
    };

    return (
        <Modal
            title="确认"
            visible={visible}
            onCancel={handleCancel}
            onOk={handleOk}
            okText="确认"
            cancelText="取消"
            destroyOnClose
        >
            <p style={{ margin: 0 }}>{content || '是否确认标记为重做状态'}</p>
        </Modal>
    );
}
